module.exports = __webpack_public_path__ + "media/images/lb/001-4e7d68be35955ddd389f7ab8dbedb767.svg";